module.exports = __webpack_public_path__ + "img/icon_map_ljcjg.1288fdcc.png";